"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importDefault(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const appStoreHyperlink = 'https://apps.apple.com/br/app/habit-nest/id1539986642';
const appGooglePlayLink = 'https://play.google.com/store/apps/details?id=com.habitnest';
const SubscriptionSuccessModal = () => {
    const onClose = () => {
        components_1.modalEvents.remove();
    };
    return (react_1.default.createElement(components_1.ModalTemplate, { title: constants_1.default.subscriptions.youAreSetToGo, onClose: onClose, ariaLabel: constants_1.default.subscriptions.youAreSetToGo, width: 630 },
        react_1.default.createElement("p", { className: styles_scss_1.default.original, dangerouslySetInnerHTML: { __html: constants_1.default.subscriptions.simplyGo(appStoreHyperlink, appGooglePlayLink) } })));
};
exports.default = SubscriptionSuccessModal;
